namespace advisorop.components.servicer {

    interface ILinkMaintenanceController {
        $router;
    }

    class LinkMaintenanceController implements ILinkMaintenanceController {

        $router;

        dgLinkTypes: DevExpress.ui.dxDataGridOptions;

        linkTypes: Array<domains.ILinkType> = [];
        linkType: domains.ILinkType = {};

        categories: Array<string> = [];

        SaveButtonLabel: string = "Add New Link Type";

        newCategoryName: string = "";




        static $inject = ["identityService", "servicerService", "generalService"];
        constructor(private identityService: services.IdentityService,
            private servicerService: services.ServicerService, private generalService: services.GeneralService) {

            this.dgLinkTypes = {
                export: {
                    enabled: true,
                    fileName: "LinkTypes"
                },
                bindingOptions: {
                    dataSource: "vm.linkTypes"
                },
                paging: { pageSize: 10 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no link types",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "categoryName", caption: "Category" },
                    { dataField: "forward", caption: "Forward" },
                    { dataField: "reverse", caption: "Reverse" },
                    { dataField: "forIndividuals", caption: "For Individuals" },
                    { dataField: "forEntities", caption: "For Entities" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", width: "110" }
                ]
            };
        }

        editLinkType(linkType: domains.ILinkType): void {
            this.linkType = linkType;
            this.newCategoryName = '';
            this.SaveButtonLabel = "Save Changes";
        };

        newLinkType(): void {
            this.SaveButtonLabel = "Add New Link Type";
            this.linkType = {};
            this.newCategoryName = "";
        }

        saveLinkType(): void {
            if (this.newCategoryName != undefined && this.newCategoryName != null && this.newCategoryName.length > 0)
                        this.linkType.categoryName = this.newCategoryName;

            if (!this.linkType ||
                (this.linkType.forward && this.linkType.forward.length <= 0) ||
                (this.linkType.reverse && this.linkType.reverse.length <= 0) ||
                (!this.linkType.forIndividuals && !this.linkType.forEntities) ||
                (this.newCategoryName && this.newCategoryName.length <= 0)
            ) {
                toastr.error("Please fill in the form.");
            }
            else {

                this.servicerService.saveLinkType(this.linkType)
                    .success((data) => {
                        this.newLinkType();
                        this.loadLinkTypeCategories();
                        this.loadLinkTypes();
                        toastr.success("Link type has been saved.");
                    })
                    .error((data, status) => {
                        toastr.error("Link type could not be saved! " + status + ":" + data);
                    });
            }
        }

        logout(): void {
            this.identityService.logout();
        }

        $onInit(): void {
            this.loadLinkTypes();
            this.loadLinkTypeCategories();
        }

        loadLinkTypes(): void {
            this.generalService.getLinkTypes()
                .then((response) => {
                    this.linkTypes = response.data;
                    //console.log('linkTypes', this.linkTypes);
                })
                .catch(err => {
                    toastr.error("Couldn't fetch Link Types. " + err.data);
                });
        };

        loadLinkTypeCategories(): void {
            this.generalService.getLinkTypeCategories()
                .then((response) => {
                    this.categories = response.data;
                    //console.log('categories', this.categories);
                })
                .catch(err => {
                    toastr.error("Couldn't fetch Link Type Categories. " + err.data);
                });
        };

        //$onChanges(evt): void {
        //    for (var key in evt) {
        //        if (key === "managerId") {
        //            if (this.managerId > 0) {
        //                //this.getManagerById(this.managerId);
        //                this.loadManagerProductTypes(this.managerId);
        //            }
        //        }
        //    }
        //}

        $routerOnActivate(next, previous) {
        }
    }



    class LinkMaintenance implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = ["identityService", "servicerService", LinkMaintenanceController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/link-maintenance.html';
        }
    }
    angular.module(Constants.APP).component("linkMaintenance", new LinkMaintenance());


}